import { Component, OnInit } from '@angular/core';
import { PatientStore } from 'app/@core/stores/patient.store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'ngx-food-diary-container',
  templateUrl: './food-diary-container.component.html',
  styleUrls: ['./food-diary-container.component.scss']
})
export class FoodDiaryContainerComponent implements OnInit {

  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  private _patientLoaded: boolean = false;

  constructor(private patientStore: PatientStore) { }

  patientId: number;
  userId:number;
  day: Date;

  get dayTitle():string  {
    if (new Date().toDateString() === new Date(this.day).toDateString()) return "Today";
    return this.day.toDateString();
  }

  ngOnInit(): void {
    this.day = new Date();
    this.loadPatient();
  }


  loadPatient() {

    this.patientStore
      .onPatientChanged()
      .pipe(
        takeWhile(() => !this._patientLoaded),
        takeUntil(this.unsubscribe$),
        filter((patient) => !!patient)
      )
      .subscribe((patient) => {
        this.patientId = patient.id;
        this.userId = patient.createdByUserId;
        this.day = new Date();
      });
  }


  previous(): void {

    let date = new Date(this.day);
    date.setDate(this.day.getDate() - 1);
    this.day = date;
  }


  next(): void {

    let date = new Date(this.day);
    date.setDate(this.day.getDate() + 1);
    this.day = date;
  }



}

